import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ProfilePage = () => {
    const [formData, setFormData] = useState({
        organization_name: '',
        contact_name: '',
        job_title: '',
        tenure: '',
        industry: '',
        custom_industry: '', // For the "Other" option
    });
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');

    // List of industries
    const industries = [
        'Technology',
        'Healthcare',
        'Finance',
        'Retail',
        'Manufacturing',
        'Education',
        'Energy',
        'Pharmaceutical',
        'Hospitality',
        'Telecommunications',
        'Real Estate',
        'Automotive',
        'Media & Entertainment',
        'Logistics & Supply Chain',
        'Agriculture',
        'Government',
        'Aerospace',
        'Insurance',
        'Construction',
        'Other',
    ];

    useEffect(() => {
        const fetchProfile = async () => {
            const username = localStorage.getItem('username'); // Retrieve logged-in employer's username
            if (!username) {
                setMessage('No username found. Please log in.');
                return;
            }

            try {
                const response = await axios.get(`http://127.0.0.1:5000/employers/profile?username=${username}`);
                setFormData(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching profile:', error);
                setMessage('Failed to fetch profile. Please try again later.');
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const username = localStorage.getItem('username'); // Retrieve logged-in employer's username
        if (!username) {
            setMessage('No username found. Please log in.');
            return;
        }

        try {
            const response = await axios.put('http://127.0.0.1:5000/employers/profile', {
                ...formData,
                username,
                industry: formData.industry === 'Other' ? formData.custom_industry : formData.industry, // Save custom industry if "Other" is selected
            });

            if (response.status === 200) {
                setMessage('Profile updated successfully.');
            } else {
                setMessage('Failed to update profile.');
            }
        } catch (error) {
            console.error('Error updating profile:', error);
            setMessage('Failed to update profile. Please try again later.');
        }
    };

    if (loading) {
        return <p>Loading profile... Please wait.</p>;
    }

    return (
        <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
            <h2>Update Profile</h2>
            {message && <p style={{ color: 'red' }}>{message}</p>}
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '15px' }}>
                    <label>Organization Name:</label>
                    <input
                        type="text"
                        name="organization_name"
                        value={formData.organization_name}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Contact Name:</label>
                    <input
                        type="text"
                        name="contact_name"
                        value={formData.contact_name}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Job Title:</label>
                    <input
                        type="text"
                        name="job_title"
                        value={formData.job_title}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Tenure:</label>
                    <input
                        type="text"
                        name="tenure"
                        value={formData.tenure}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Industry:</label>
                    <select
                        name="industry"
                        value={formData.industry}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    >
                        <option value="">-- Select Industry --</option>
                        {industries.map((industry, index) => (
                            <option key={index} value={industry}>
                                {industry}
                            </option>
                        ))}
                    </select>
                </div>
                {formData.industry === 'Other' && (
                    <div style={{ marginBottom: '15px' }}>
                        <label>Specify Industry:</label>
                        <input
                            type="text"
                            name="custom_industry"
                            value={formData.custom_industry}
                            onChange={handleChange}
                            required
                            style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                        />
                    </div>
                )}
                <button
                    type="submit"
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#007BFF',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Update Profile
                </button>
            </form>
        </div>
    );
};

export default ProfilePage;

